export const initEnMenu = () => {
	const navigation = document.querySelector( 'body.en > nav' );

	if ( !navigation )
	{
		return;
	}

	window.scrollBy( 0, navigation.getBoundingClientRect().top );
};